import PropTypes from 'prop-types';
import React from 'react';
import QuantitySelector from '~/components/Generic/QuantitySelector';

const ProductQuantitySelector = ({ handleChange, isHoodie, ...props }) => {
  const selectionLimit = isHoodie ? 5 : 20;
  const maxQuantity = Math.min(selectionLimit, props.currentVariantInStock) || 1;
  const options = [...Array(maxQuantity)].map((_, i) => ({
    name: (i + 1).toString(),
    value: i + 1,
  }));

  return (
    <QuantitySelector
      handleChange={handleChange}
      options={options}
      {...props}
      outOfStock={props.currentVariantInStock === 0}
    />
  );
};

ProductQuantitySelector.propTypes = {
  handleChange: PropTypes.func,
};

export default ProductQuantitySelector;
